/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { Directive, Input } from '@angular/core';
import { logWarning } from '@gh/core-util';
import { GridOptions } from 'ag-grid-community';
import { isEmpty, isNil } from 'lodash';

import {
  GRID_FEATURE,
  GridFeature,
  GridFeatureInitParams,
  GridFeatureReadyParams,
} from '../feature.interfaces';

@Directive({
  standalone: false,
  selector: '[ghGridTreeData]',
  providers: [{
    provide: GRID_FEATURE,
    useExisting: GridTreeDataDirective,
    multi: true,
  }],
})
export class GridTreeDataDirective implements GridFeature {
  @Input('ghGridTreeData') groupBy: string;
  @Input('ghGridTreeDataHasChildren') hasChildren: string;
  @Input('ghGridTreeDataExpanded') expanded: string;

  initGrid(params: GridFeatureInitParams): void {
    // nothing to do
  }

  enhanceGridOptions(options: GridOptions): void {
    const { groupBy } = this;

    if (isNil(options.getRowId)) {
      throw new Error(`GridTreeDataDirective: getRowId should be defined for tree data`);
    }

    if (isEmpty(groupBy)) {
      throw new Error(`GridTreeDataDirective: groupBy should be defined for tree data`);
    }

    logWarning(
      'GridTreeDataDirective: legacy groupStage grouping is no longer applied. ' +
      'Migrate to AG Grid treeData/getDataPath or pre-process hierarchical data.',
    );
  }

  onGridReady(params: GridFeatureReadyParams): void {
    // nothing to do
  }

  onDestroy(): void {
    // nothing to do
  }
}
